import LoadingSimple from '__core/modules/components/LoadingSimple';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useLinkLoginPage from './useLinkLoginPage';

function LinkLoginPage() {
  const { t } = useTranslation();
  useLinkLoginPage();

  return <LoadingSimple title={t('auth:link_login_loading')} />;
}

export default LinkLoginPage;
